module.exports = __webpack_public_path__ + "static/logo-6db07217a7a7a20bccd0dadd0fcd1454.png";